<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      v-if="open"
      d="M4 24V21.3333H28V24H4ZM4 17.3333V14.6667H28V17.3333H4ZM4 10.6667V8H28V10.6667H4Z"
      fill="white"
    />
    <path
      v-else-if="close"
      d="M8.53268 25.3327L6.66602 23.466L14.1327 15.9993L6.66602 8.53268L8.53268 6.66602L15.9993 14.1327L23.466 6.66602L25.3327 8.53268L17.866 15.9993L25.3327 23.466L23.466 25.3327L15.9993 17.866L8.53268 25.3327Z"
      fill="white"
    />
  </svg>
</template>

<script setup lang="ts">
defineProps<{ open: true, close?: never } | { open?: never, close: true }>()
</script>
